module.exports = __webpack_public_path__ + "assets/img/picture4.969f3e86.svg";